export default () => ({
  index: [],
  leverdag: {},
  orders: [],
});
